import { render, staticRenderFns } from "./BlockDescriptionListPart.vue?vue&type=template&id=b381fed2&scoped=true&"
import script from "./BlockDescriptionListPart.vue?vue&type=script&lang=js&"
export * from "./BlockDescriptionListPart.vue?vue&type=script&lang=js&"
import style0 from "./BlockDescriptionListPart.vue?vue&type=style&index=0&id=b381fed2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b381fed2",
  null
  
)

export default component.exports